<div odxLayout="flex gap-small" class="flex-column h-100">
  <odx-area-header>
    <h5 class="odx-title-5" i18n="@@documentUpload.documentOverview.header">Dateien</h5>
    <odx-area-header-content>
      @if ((isReadOnlyUser$ | async) === false) {
        <odx-action-group class="mobile-file-actions" [odxTooltip]="offlineToolTipMessage">
          <button
            odxButton
            variant="primary"
            (click)="fileUpload.click()"
            data-testid="btn.uploadDocument"
            [disabled]="!navigator.onLine || (hasWritePermission$ | async) === false"
          >
            <odx-icon name="upload" size="medium" alignleft></odx-icon>
            <span i18n="@@documentUpload.button.uploadDocument">Datei hochladen</span>
          </button>
        </odx-action-group>
      }
      <input type="file" (change)="onFileSelected($event)" class="hidden" multiple #fileUpload data-testid="input.documentName" />
    </odx-area-header-content>
  </odx-area-header>
  <ng-content></ng-content>
</div>
